import axios from '@/lib/axios';
import { BoardSetting, User } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2480. Board連携設定登録
 * [POST] /workspaces/:identifier/board_setting
 */
type Props = {
  identifier: string;
  api_key: string;
  api_token: string;
};
const createBoardSetting = (props: Props): Promise<BoardSetting> => {
  return axios.post(`/api/workspaces/${props.identifier}/board_setting`, props);
};

export const useCreateBoardSetting = () => {
  return useMutation({
    mutationFn: createBoardSetting,
  });
};
